module.exports = __webpack_public_path__ + "static/media/welcomeScreenTotemGlasses.9eb8a4a3.png";